// extracted by mini-css-extract-plugin
export default {"root":"TermsOfService_root__jagBW","listStyle":"TermsOfService_listStyle__91w3P","lastUpdated":"TermsOfService_lastUpdated__Vdfsr marketplaceBodyFontStyles"};